export const CRM_BASE_URL = process.env.REACT_APP_ASSURANCE_BASE_URL;
export const AGENT_DASHBOARD_URL = `${CRM_BASE_URL}/agent`;
export const PLATES_URL = `${CRM_BASE_URL}/rep/plate`;
export const LEAD_LOOKUP_URL = `${CRM_BASE_URL}/agent/lookup_lead`;
export const CRM_PATH_QUERY_PARAM_KEY = "iframe_path";
